// extracted by mini-css-extract-plugin
export default {"card-iframe-wrapper":"styles_card-iframe-wrapper__uKZIW","card-iframe":"styles_card-iframe__GYx+2"};